import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'theme-ui';
import { Auth0Provider } from '@auth0/auth0-react';
import { theme } from './theme';
import App from './App';
import store from './state/store';
import './assets/_fonts.css';
import 'react-tooltip/dist/react-tooltip.css';
import { DoppioProvider, snap } from '@odekoteam/doppio';
import 'form-request-submit-polyfill';
import ErrorBoundary from './components/ErrorBoundary';
import { initErrorReporter } from '@/services/ErrorReporter';
import AnalyticsProvider from '@/providers/AnalyticsProvider';

initErrorReporter();

const domain = window.env.AUTH0_DOMAIN;
const clientId = window.env.AUTH0_CLIENT_ID;
const audience = window.env.AUTH0_AUDIENCE;

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}
const root = createRoot(container);

root.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience,
      // v2 no longer auto-appends the OIDC scopes when an explicit scope is
      // set, so list them here — `openid` is required for the ID token that
      // carries the `https://odeko.com/roles` claim the admin gate reads.
      scope:
        'openid profile email read:current_user update:current_user_metadata',
    }}
    onRedirectCallback={(appState) => {
      // Redirect to the originally requested page after login
      const returnTo = appState?.returnTo || '/';
      window.history.replaceState({}, document.title, returnTo);
    }}
  >
    <StrictMode>
      <Provider store={store}>
        <AnalyticsProvider>
          <DoppioProvider
            applicationName="item-management-web"
            _theme={snap}
            _logLevel="silent"
          >
            <ThemeProvider theme={theme}>
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </ThemeProvider>
          </DoppioProvider>
        </AnalyticsProvider>
      </Provider>
    </StrictMode>
  </Auth0Provider>,
);
